/**
 * The main entry point for the client.
 */
import clientCommon from './entry-client-common';
import createStore from './create-store';

const { store } = createStore();

clientCommon({ router: null, store });
